import type { CategoryTile } from "@/types/movie";

export const categoryTiles: CategoryTile[] = [
  {
    key: "new",
    title: "最新上映",
    english: "LATEST",
    desc: "近期上线的韩国作品，第一时间跟进剧情与口碑。",
    count: "428 部",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20artwork%20of%20a%20warm%20amber%20cinema%20spotlight%20cutting%20through%20dark%20theatre%20dust%2C%20deep%20crimson%20velvet%20curtain%20edge%2C%20soft%20glow%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=640&height=420&seq=krfilm-cat-new&orientation=landscape",
    to: "/category?c=new",
  },
  {
    key: "classic",
    title: "经典收藏",
    english: "CLASSICS",
    desc: "十年以上仍被反复讨论的作品，资料最完整的一档。",
    count: "612 部",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20artwork%20of%20stacked%20vintage%2035mm%20film%20reels%20in%20warm%20amber%20light%2C%20deep%20crimson%20shadows%2C%20dust%20particles%20floating%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20nostalgic%20mood%2C%20no%20text%2C%20no%20lettering&width=640&height=420&seq=krfilm-cat-classic&orientation=landscape",
    to: "/category?c=classic",
  },
  {
    key: "hot",
    title: "热门推荐",
    english: "TRENDING",
    desc: "本周访问量与讨论度最高的影片，持续更新。",
    count: "236 部",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20artwork%20of%20glowing%20amber%20and%20crimson%20light%20streaks%20crossing%20a%20dark%20cinema%20hall%2C%20blurred%20lens%20flare%2C%20smoke%20haze%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20dynamic%20mood%2C%20no%20text%2C%20no%20lettering&width=640&height=420&seq=krfilm-cat-hot&orientation=landscape",
    to: "/category?c=hot",
  },
  {
    key: "by-year",
    title: "按年份浏览",
    english: "BY YEAR",
    desc: "从 2010 到 2025，按年份逐年梳理作品脉络。",
    count: "1980 部",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20artwork%20of%20a%20wall%20of%20vintage%20calendar%20pages%20lit%20by%20warm%20amber%20light%2C%20deep%20crimson%20tones%2C%20shallow%20depth%20of%20field%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20quiet%20nostalgic%20mood%2C%20no%20text%2C%20no%20lettering&width=640&height=420&seq=krfilm-cat-year&orientation=landscape",
    to: "/category?c=by-year",
  },
];

export const genreOptions = ["全部", "爱情", "剧情", "悬疑", "都市"];

export const yearOptions = [
  { label: "全部年份", value: "all" },
  { label: "2024 及以后", value: "2024" },
  { label: "2020 - 2023", value: "2020" },
  { label: "2015 - 2019", value: "2015" },
  { label: "2014 及以前", value: "classic" },
];

export const collectionLabels: Record<string, string> = {
  new: "最新上映",
  classic: "经典收藏",
  hot: "热门推荐",
  "by-year": "按年份浏览",
  all: "全部影片",
};